/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Any_Extra_Beetle_PraiseInputs */

const fr_any_extra_beetle_praise = /** @type {(inputs: Any_Extra_Beetle_PraiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurer une séance pour le programme hebdomadaire`)
};

/**

* @param {Any_Extra_Beetle_PraiseInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const any_extra_beetle_praise = /** @type {((inputs?: Any_Extra_Beetle_PraiseInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Any_Extra_Beetle_PraiseInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_any_extra_beetle_praise(inputs)
});